var exports = {
  "hl": "PopoverContent__R9bXKj",
  "CU": "learnMoreLink__sfxd0T",
  "$I": "copilotButton__lh5LJc",
};

module.exports = exports;
